module.exports = __webpack_public_path__ + "img/scooter.1f5cf3c5.svg";